"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
const scriptEventProxyFactory_1 = require("./internal/scriptEventProxyFactory");
let InaxScriptService = InaxScriptService_1 = class InaxScriptService {
    constructor(_http, _configuration, _profileService) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
    }
    get hubName() {
        return "ScriptHub";
    }
    /***********************************************************************
     *          SIGNALR
     * ********************************************************************/
    registerEvents(signalR) {
        if (this._configuration.UseSignalR && this._configuration.EnabledSignalRHubs.indexOf(this.hubName) >= 0) {
            InaxScriptService_1._proxyFactory = new scriptEventProxyFactory_1.ScriptEventProxyFactory(signalR.getHubProxy(this.hubName));
        }
    }
    create(scriptUnit, functionName) {
        if (InaxScriptService_1._proxyFactory == null)
            throw "proxy not initialized";
        return InaxScriptService_1._proxyFactory.create(scriptUnit);
    }
    executeInClientContextAsync(scriptUnit, functionName, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.executeInClientContext(scriptUnit, functionName, parameters).toPromise();
        });
    }
    //Start a function on a ScriptUnit in the client context.
    executeInClientContext(scriptUnit, functionName, parameters) {
        if (InaxScriptService_1._proxyFactory == null)
            throw "proxy not initialized";
        return InaxScriptService_1._proxyFactory.invoke(scriptUnit, functionName, parameters, false);
    }
    //invoke a script function on the server, and get events
    invokeInClientContext(scriptUnit, functionName, parameters) {
        if (InaxScriptService_1._proxyFactory == null)
            throw "proxy not initialized";
        // Now we just create our internal object so we can track this subject
        // in case someone else wants it too
        return InaxScriptService_1._proxyFactory.invoke(scriptUnit, functionName, parameters, true);
    }
    setScriptPropertyInClientContext(scriptUnit, propertyName, propertyValue) {
        if (InaxScriptService_1._proxyFactory == null)
            throw "proxy not initialized";
        // Now we just create our internal object so we can track this subject
        // in case someone else wants it too
        InaxScriptService_1._proxyFactory.setProperty(scriptUnit, propertyName, propertyValue);
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    //Get a property from the script from the server context
    getScriptPropertyValueInServerContext(scriptUnit, propertyName) {
        let accessUrl = this._configuration.buildRestUrl("Script", "GetScriptPropertyValue") + "?scriptUnit=" + scriptUnit + "&propertyName=" + propertyName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map((res) => this.mapToAny(res));
    }
    //Set a property in the script in the server context
    setScriptPropertyInServerContext(scriptUnit, propertyName, propertyValue) {
        let accessUrl = this._configuration.buildRestUrl("Script", "SetScriptPropertyValue") + "?scriptUnit=" + scriptUnit + "&propertyName=" + propertyName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(propertyValue), { headers }).map((res) => res.ok);
    }
    //Start a function on a ScriptUnit in the server context (so no client property change) and did not wait for the result.
    executeInServerContext(scriptUnit, functionName, parameters) {
        let accessUrl = this._configuration.buildRestUrl("Script", "RunScript") + "?scriptUnit=" + scriptUnit + "&function=" + functionName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, JSON.stringify(parameters), { headers }).map((res) => res.ok);
    }
    //invoke e script function on the server and return the result
    invokeInServerContext(scriptUnit, functionName, parameters) {
        let accessUrl = this._configuration.buildRestUrl("Script", "InvokeScriptMethod") + "?scriptUnit=" + scriptUnit + "&function=" + functionName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        if (parameters != null && parameters.length > 0) {
            accessUrl += "&parameters=";
            for (var index = 0; index < arguments.length; index++) {
                accessUrl += arguments[index];
                if (index + 1 < arguments.length)
                    accessUrl += ",";
            }
        }
        return this._http.get(accessUrl, { headers }).map((res) => this.mapToAny(res));
    }
    normalizeUri(uri) {
        return encodeURIComponent(uri);
    }
    mapToAny(res) {
        try {
            return res.json();
        }
        catch (Exception) {
            return res.text();
        }
    }
};
InaxScriptService = InaxScriptService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService])
], InaxScriptService);
exports.InaxScriptService = InaxScriptService;
var InaxScriptService_1;
